import { Component, OnInit } from '@angular/core';
import { DriversService } from '../../services/drivers.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { Driver,DriverProgramming,DriverListIcipia,DriverApiCipia } from '../../models/interfaces';
import { VehicleList } from 'src/app/multiview/models/interfaces';
import { Vehicle } from 'src/app/vehicles/models/vehicle';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { MenuItem } from 'primeng-lts/api';
import { inArray } from 'jquery';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';
import { DriverEnrollmentService, EnrollmentRequestHistory } from '../../services/driver-enrollment.service';
import { VehicleEnrolledConfig } from '../../services/driver-enrollment.service';

@Component({
  selector: 'app-driver-enrollment-modal',
  templateUrl: './driver-enrollment-modal.component.html',
  styleUrls: ['./driver-enrollment-modal.component.scss']
})
export class DriverEnrollmentModalComponent implements OnInit {

  selectedVehicle!: string | null;
  vehicles: VehicleList[] = [];

  listDriversFull: DriverProgramming[] = [];
  selectedDrivers : DriverProgramming | undefined;

  listDriverEnrolled: DriverProgramming[] = [];
  selectedDriversEnrolled : DriverProgramming | undefined;

  driversUnknown: number=0;
  messageDriversUnknown: string='';
  responseMessages: { [key: number]: { title: string, text: string, icon: any } } = {
    200: {
      title: 'Éxito',
      text: 'La solicitud se realizó correctamente.',
      icon: 'success'
    },
    500: {
      title: 'Error',
      text: 'Hubo un error interno del servidor. Inténtelo más tarde.',
      icon: 'error'
    },
    404: {
      title: 'No Encontrado',
      text: 'No se pudo encontrar la lista de Conductores.',
      icon: 'warning'
    },
    403: {
      title: 'Dispositivo No Encontrado',
      text: 'El dispositivo CIPIA no se encuentra en el servidor, comunicar al área de TI.',
      icon: 'error'
    },
    415: {
      title: 'Enrolamiento Fallido',
      text: 'El dispositivo CIPIA no reconoce el código Icipia, comunicar al área de TI.',
      icon: 'error'
    },
    408: {
      title: 'Tiempo de espera Agotado',
      text: 'El dispositivo CIPIA no respondió a tiempo, verificar que tengan ignición y conexión a internet.',
      icon: '<i class="fas fa-hourglass-end"></i>'
    },
    422: {
      title: 'Falta de información',
      text: 'La solicitud no se pudo completar, falta la información necesaria para el proceso.',
      icon: 'warning'
    },
  };

  constructor(
    public driversService: DriversService,
    public vehicleService: VehicleService,
    private unitTransmission : UnitTransmissionStatusService,
    private driverEnrollmentService : DriverEnrollmentService
  ) { }

  public vehicleConfigEnrolled : VehicleEnrolledConfig | undefined;

  menuItemsConductores : any[] = [];
  menuItemsEnrolled : any[] = [];

  public unitStates : any[] = []
  public selectedStates : any[] = []

  public vehicleOptions : any[] = []
  public allUnitStates : any[] = []
  public filteredUnits : any[] = []
  public selectedUnit : any 
  public historyRequest : EnrollmentRequestHistory = {}
  public contextMenuEnrolledEnabled : boolean = false;
  public contextMenuDriverEnabled : boolean = false;
  public showHistorial : boolean = false;
  public showHistoryPanel() {
    this.showHistorial = !this.showHistorial;
  }

  // control permission
  public hasEnrolledInDriversList = false;
  public hasUnrolledInEnrollmentList = false;

  ngOnInit(): void {
    this.unitStates = this.unitTransmission.getTransmissionStates()
    this.unitTransmission.getUnitsTransmissionStates.subscribe((unitStates)=>{
      this.allUnitStates = unitStates
      console.log("unitsta", this.allUnitStates)
      this.updateFilteredUnits()
    })
    this.vehicles = this.vehicleService.vehicles
    .filter(vh => vh.IMEI!.startsWith('E'))
    .map(vh => {
      return {
        id: vh.id!,
        vehicle_id: vh.vehicle_id,
        IMEI: vh.IMEI,
        name: vh.name!,
        numero_placa: vh.numero_placa!,
        cod_interno: vh.cod_interno!,
      }
    });

    this.driverEnrollmentService.getEnrollmentRequestHistory().subscribe((history)=>{
      console.log("enrollment : nuevo history", history, this.selectedVehicle)
      this.historyRequest = history
      this.transformHistoryRequest();
      this.updateList()
      this.controllAccessEnrolled();
    })
    this.loadMenuItems()

    if(this.driverEnrollmentService.hasEnrolledPermission){
      this.hasEnrolledInDriversList = true
    }
    if(this.driverEnrollmentService.hasUnrolledPermission){
      this.hasUnrolledInEnrollmentList = true
    }
    
  }

  get filteredDriverEnrolled() {
    const enrolados = this.listDriverEnrolled.filter((er)=>{
      return er.savedConfirm == true
    })
    return enrolados.length
  }

  onDriverRowClick(event: any) {
    this.selectedDriver = event
    console.log("enrolar evento", event)
  }

  onDriverEnrolledRowClick(event: any) {
    const driver: DriverProgramming = event;

    // Si está en proceso, no seleccionar nada
    if (driver.status === 'loading') {
      this.selectedDriver = undefined;
      this.selectedDriversEnrolled = undefined;
      return;
    }

    // Error al desenrolar: seleccionar como `selectedDriversEnrolled` para reintentar
    if (driver.status === 'error' && driver.type === 'desenrolar') {
      this.selectedDriver = undefined;
      this.selectedDriversEnrolled = driver;
      return;
    }

    // Si está enrolado correctamente: permitir desenrolar
    if (driver.status === 'success' && driver.type === 'enrolar') {
      this.selectedDriver = undefined;
      this.selectedDriversEnrolled = driver;
      return;
    }

    if (driver.status === 'error' && driver.type === 'enrolar') {
      this.selectedDriver = driver;
      this.selectedDriversEnrolled = undefined;
      return;
    }
    // En cualquier otro caso: limpiar selección
    this.selectedDriver = undefined;
    this.selectedDriversEnrolled = undefined;
  }
  public transformedHistory: {
    imei: string;
    requests: { driverID: string; data: DriverApiCipia }[];
  }[] = [];


  private controllAccessEnrolled() {
    if(this.driverEnrollmentService.enrollmentAccess){
      this.contextMenuDriverEnabled = true;
      this.contextMenuEnrolledEnabled = true;

      if(this.vehicleConfigEnrolled && this.selectedVehicle){
        const enrolledDrivers = this.countSuccessfulEnrollments(this.selectedVehicle)
        if(this.vehicleConfigEnrolled.onlyOneEnrolled){
          if(enrolledDrivers >= 1){
            this.contextMenuDriverEnabled = false;
            this.contextMenuEnrolledEnabled = false;
          }
        }

        if(enrolledDrivers >= this.vehicleConfigEnrolled.limit){
          this.contextMenuDriverEnabled = false;
        }
      }
    }
  }

  public countSuccessfulEnrollments(imei: string) {
    const drivers = this.historyRequest[imei] ?? {};
    return Object.values(drivers).filter(driver =>
      driver.type === 'enrolar'
    ).length;
  }

  private transformHistoryRequest() {
    this.transformedHistory = Object.entries(this.historyRequest).map(
      ([imei, drivers]) => ({
        imei,
        requests: Object.entries(drivers).map(([driverID, data]) => ({ driverID, data })),
      })
    );
  }

  public driverEnrolledConfirm : DriverProgramming[] = []
  // actualizar lista de enrolamiento de conductores
  public selectVehicleUnit() {
    if(this.selectedUnit?.GNSSIMEI){
      this.selectedVehicle = this.selectedUnit?.GNSSIMEI
      if(this.selectedVehicle){
        this.driversService.spinner.show('loadingListDriverEnroll');
        this.listDriverEnrolled = [];
        this.listDriversFull = [];
        this.vehicleConfigEnrolled = this.driverEnrollmentService.getVehicleConfig(this.selectVehicleUnit)
        this.driverEnrollmentService.getDriverEnrolledFromVehicle(this.selectedVehicle).subscribe({
          next: (drivers) => {
            this.driverEnrolledConfirm = this.driverEnrollmentService.tranformCipiaListToDrivers(drivers)
            this.driverEnrollmentService.getDriverEnrolledHistoryList(drivers, this.selectedVehicle!)
            this.setUnknownDriversEnrolled(drivers.length);
            this.driversService.spinner.hide('loadingListDriverEnroll');
            this.alertByCode(200,'Lista de Conductores Actualizada.'); // Mostrar SweetAlert basado en el código
          },
          error: (error : any) => {
            this.selectedVehicle = null;
            this.driversService.spinner.hide('loadingListDriverEnroll');
            const statusCode = error.status || 500;
            this.alertByCode(statusCode); // Mostrar SweetAlert en caso de error
          }
        });
      }
    }
  }

    // Mover de Lista Drivers a List Para Enrollar
  public sendListDriversToEnrollment(){
    if(!this.selectedDriver){
      Swal.fire({
        title: 'Conductor No Seleccionado',
        text: 'Debe seleccionar un Conductor para realizar el enrolamiento con el dispositivo.',
        icon: 'warning',
      });
    }else{
      //this.driversService.spinner.show('loadingListDriverEnroll');

      const driverApiCipia: DriverApiCipia = {
        deviceID: this.selectedVehicle!, // tracker_imei es el UnitID o DeviceID
        driverID: this.selectedDriver.key_number,  // Aquí asignamos el key_number a driverID
        driverProgrammingID: this.selectedDriver.id, // Id de la Programación
        type : "enrolar",
        savedConfirm : this.selectedDriver.savedConfirm
      };
      console.log('Asignar Enrolamiento de : ',driverApiCipia);
      
      
      //this.moveDriverToListEnrolled(this.selectedDriver?.driver_id!)
      this.driverEnrollmentService.sendDriverEnrollmentRequest(driverApiCipia)
      this.selectedDriver = undefined
      //this.driversService.sendDriverEnrollmentRequest(driverApiCipia)

      return;
      this.driversService.addDriverEnrolled(driverApiCipia).subscribe(
        (response) => {
          this.alertByCode(200,'Conductor Enrolado Correctamente.');
          this.driversService.spinner.hide('loadingListDriverEnroll');
        },
        (error: { status: number,error:any; }) => {
          // console.log('Error en la petición ->', error);
          const statusCode = error.status || 500;
          if(statusCode == 422){
          this.alertByCode(statusCode,error.error.messages);
          }else{
            this.alertByCode(statusCode);
          }
          this.driversService.spinner.hide('loadingListDriverEnroll');
        }
      );
    }

  }

  public updateList(){
    this.listDriverEnrolled = [];
    this.listDriversFull = [];
    if(this.selectedVehicle){
      const {enrolled, notEnrolled} =this.driverEnrollmentService.getDriverLists(this.historyRequest[this.selectedVehicle] || [])
      this.listDriverEnrolled = enrolled;
      this.listDriversFull = notEnrolled;

      console.log("definir limite", this.listDriverEnrolled)
    }
  }

  public formarListDriver(){
    if(this.selectedVehicle){
      const vehicleHistory = this.historyRequest[this.selectedVehicle || ""]
      console.log("enrollment : acutalizar lista", this.listDriverEnrolled, this.listDriversFull, vehicleHistory)
    }
  }


  public selectedDriver : any;
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  updateFilteredUnits() {
    const selectedValues = [1,2];

    const filteredStates = this.allUnitStates.filter(state =>
      selectedValues.includes(state.transmissionStatusId)
    );
    
    console.log("vehiculos driver units", filteredStates)
    const allVehicles = filteredStates.reduce((acc, state) => {
      const filteredVehicles = state.unitsTransmissions.filter((vh : any) => vh.GNSSIMEI?.startsWith('E'));
      return acc.concat(filteredVehicles);
    }, []);
    console.log(allVehicles, "FILTRAR VEHIULOS")
    this.filteredUnits = allVehicles
    // Opcional: Validar si el seleccionado anterior aún existe
    if (
      this.selectedUnit &&
      !this.filteredUnits.some(u => u.GNSSIMEI === this.selectedUnit?.GNSSIMEI)
    ) {
      this.selectedUnit = null;
    }
  }

  async listedByDriver(){
    this.listDriverEnrolled = [];
    this.listDriversFull = [];

    console.log(this.selectedVehicle);
    if(!this.selectedVehicle){
      return ;
    }
    this.driversService.spinner.show('loadingListDriverEnroll');
    return;
    return;
    this.driversService.spinner.show('loadingListDriverEnroll');
    // Ejecutar la petición
    this.driversService.getDriversEnrolledList("").subscribe(
      (response: { data: { code: string; }; }) => {
        this.driversService.spinner.hide('loadingListDriverEnroll');

        let jsonParse = JSON.parse(response.data.code);
        console.log(jsonParse, "obtener lista vehiculos");
        this.setListDriversByResponse(jsonParse);
        this.setUnknownDriversEnrolled(jsonParse.length);
        this.alertByCode(200,'Lista de Conductores Actualizada.'); // Mostrar SweetAlert basado en el código
      },
      (error: { status: number; }) => {
        this.selectedVehicle = null;
        this.driversService.spinner.hide('loadingListDriverEnroll');

        // console.log('Error en la petición ->', error);
        const statusCode = error.status || 500;
        this.alertByCode(statusCode); // Mostrar SweetAlert en caso de error
      }
    );
  }
  setListDriversByResponse(jsonParse:DriverListIcipia[]){
    // Filtrar los conductores para listDriverToEnrollment
    this.listDriverEnrolled = this.driversService.driversProgramming.filter(driver =>
      driver.key_type === 'ICIPIA' && driver.fecha_fin == null &&
      jsonParse.some((json) => json.driverId === driver.key_number && json.permission === true)
    );

    // Filtrar el resto de los conductores para listDriversEnrolled
    this.listDriversFull = this.driversService.driversProgramming.filter(driver =>
      (driver.key_type === 'ICIPIA' && driver.fecha_fin == null &&
        !jsonParse.some((json) => json.driverId === driver.key_number && json.permission === true))
    );

  }

  setUnknownDriversEnrolled(length:number){
    this.driversUnknown = length - this.listDriverEnrolled.length;
    if(this.driversUnknown>0){
      this.messageDriversUnknown='Incluye '+this.driversUnknown+' enrolamientos con Conductor Desconocido.';
      console.log('Existen Drivers Enrolados que no existen en la lista...');
    }else{
      this.messageDriversUnknown = '';
    }
  }
  alertByCode(code: number,msn?:string) {
    const message = this.responseMessages[code] || {
      title: 'Error desconocido',
      text: 'Ha ocurrido un error inesperado.',
      icon: 'error'
    };

    const iconsDefault : string[] = ['error','success','warning'];
    if(iconsDefault.includes(message.icon)){
      Swal.fire({
        title: message.title,
        text: msn ?? message.text,
        icon: message.icon,
      });
    }else{
      Swal.fire({
        title: message.title,
        text: msn ?? message.text,
        iconHtml: message.icon,
      });
    }
  }

  
  onDriverAction(driver: any) {
    console.log('Botón presionado para:', driver);
    // Aquí puedes hacer retry, mostrar modal, etc.
  }

  onRetryDriver(driver: any) {
  console.log('Reintentando driver:', driver);
  // Aquí llamas a tu función para reintentar enrolar
  }

  onRemoveDriver(driver: any) {
    if(driver.type == "enrolar" && driver.status == "error"){
      this.driverEnrollmentService.updateDriverEntry(this.selectedVehicle || "", driver.key_number, ()=>null)
    }
  }

  // Regresar de List Para Enrollar a Lista Drivers
  returnListDriversFull(){
    if(!this.selectedDriversEnrolled){
      Swal.fire({
        title: 'Conductor No Seleccionado',
        text: 'Debe seleccionar un Conductor para retirar enrolamiento del dispositivo.',
        icon: 'warning',
      });
    }else{
      const driverApiCipia: DriverApiCipia = {
        deviceID: this.selectedVehicle!, // tracker_imei es el UnitID o DeviceID
        driverID: this.selectedDriversEnrolled.key_number,  // Aquí asignamos el key_number a driverID
        driverProgrammingID: this.selectedDriversEnrolled.id, // Id de la Programación
        type : "desenrolar",
        status : "waiting",
        savedConfirm : this.selectedDriversEnrolled.savedConfirm
      };

      const moved = this.driverEnrollmentService.sendDriverUnrollmentRequest(driverApiCipia)
      console.log('Asignar DesEnrolamiento de : ',driverApiCipia);
      this.selectedDriversEnrolled = undefined
      //this.moveDriverToListFull(this.selectedDrivers?.driver_id!)
      return
      Swal.fire({
        title: "Eliminar Enrolamiento de Conductor",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Retirar",
        confirmButtonColor: "#FF0000"
      }).then((result) => {
        if (result.isConfirmed) {
          this.driversService.spinner.show('loadingListDriverEnroll');

          this.driversService.deleteDriverEnrolled(driverApiCipia).subscribe(
            (response) => {
              this.moveDriverToListFull(this.selectedDrivers?.driver_id!)
              this.alertByCode(200, 'Conductor Removido correctamente.');
              this.driversService.spinner.hide('loadingListDriverEnroll');
            },
            (error: { status: number; }) => {
              this.driversService.spinner.hide('loadingListDriverEnroll');
              // console.log('Error en la petición ->', error);
              const statusCode = error.status || 500;
              this.alertByCode(statusCode); // Mostrar SweetAlert en caso de error
            }
          );
        }
      });
    }
  }

  moveDriverToListEnrolled(driverId: number) {
    let auxListFull: (DriverProgramming & { status?: DriverApiCipia["status"] })[] = [...this.listDriversFull];
    let auxListEnrolled: (DriverProgramming & { status?: DriverApiCipia["status"] })[] = [...this.listDriverEnrolled];

    this.listDriversFull = [];
    this.listDriverEnrolled = [];

    const driverIndex = auxListFull.findIndex(driver => driver.driver_id === driverId);

    if (driverIndex !== -1) {
      const driver = auxListFull[driverIndex];

      // Asignamos el estado inicial si no tiene
      if (!driver.status) {
        driver.status = 'waiting';
      }

      // Agregar a la lista de enrolados
      auxListEnrolled.push(driver);
      this.listDriverEnrolled = [...auxListEnrolled];

      // Quitar de la lista general
      auxListFull.splice(driverIndex, 1);
      this.listDriversFull = [...auxListFull];

      console.log('Movido a listDriverEnrolled:', driver);
    } else {
      console.warn('No se encontró el conductor con ID:', driverId);
    }
  }
  moveDriverToListFull(driverId:number){
    let auxListFull:DriverProgramming[] = [];
    let auxListEnrolled:DriverProgramming[] = [];

    auxListFull =[...this.listDriversFull];
    auxListEnrolled =[...this.listDriverEnrolled];

    this.listDriversFull = [];
    this.listDriverEnrolled = [];

    const enrolledIndex = auxListEnrolled.findIndex(driver => driver.driver_id === driverId);

    if (enrolledIndex !== -1) {
      console.log('Encontrado en Lista Enrolados : ',enrolledIndex);

      auxListFull.push(auxListEnrolled[enrolledIndex]); // Lo agrega a listDriverEnrolled
      this.listDriversFull =[...auxListFull];

      auxListEnrolled.splice(enrolledIndex, 1);
      this.listDriverEnrolled =[...auxListEnrolled]
    }


  }

  // util menus
  onContextMenuSelect(event: any) {
    const driver: DriverProgramming = event.data;


    if (driver.status === 'loading') {
      this.menuItemsEnrolled = [];
      return;
    }

    // Limpiar menú inicial
    this.menuItemsEnrolled = [];

    if (driver.status === 'error') {
      // Reintentar según tipo
      if (driver.type === 'enrolar') {
        this.selectedDriver = driver;
        this.selectedDriversEnrolled = undefined;
        this.menuItemsEnrolled.push({
          label: 'Enrollar',
          icon: 'pi pi-sign-in',
          command: () => {
            console.log(this.selectedDriver, "Reintentando Enrollar");
            this.sendListDriversToEnrollment();
          }
        });
      }

      if (driver.type === 'desenrolar') {
        this.menuItemsEnrolled.push({
          label: 'Desenrollar',
          icon: 'pi pi-sign-out',
          command: () => {
            console.log(this.selectedDriver, "Reintentando Desenrollar");
            this.returnListDriversFull();
          }
        });
      }

    } else {
      // Acción opuesta según estado actual y permisos
      if (driver.type === 'enrolar') {
        this.menuItemsEnrolled.push({
          label: 'Desenrollar',
          icon: 'pi pi-sign-out',
          command: () => {
            console.log(this.selectedDriversEnrolled, "Desenrollar");
            this.returnListDriversFull();
          }
        });
      }

      if (driver.type === 'desenrolar') {
        this.selectedDriver = driver;
        this.selectedDriversEnrolled = undefined;
        this.menuItemsEnrolled.push({
          label: 'Enrollar',
          icon: 'pi pi-sign-in',
          command: () => {
            console.log(this.selectedDriver, "Enrollar");
            this.sendListDriversToEnrollment();
          }
        });
      }
    }
  }


  // para el lado de listas de conductores
  loadMenuItems() {
    this.menuItemsConductores = [];
    this.menuItemsEnrolled = [];

    if (this.driverEnrollmentService.hasEnrolledPermission) {
      this.menuItemsConductores.push({
        label: 'Enrollar',
        icon: 'pi pi-sign-in',
        command: () => {
          console.log(this.selectedDriver, "Enrollar");
          const hasEnrolled = this.driverEnrollmentService.hasEnrolledVehicle(
            this.selectedUnit,
            this.selectedVehicle || ""
          );
          if (hasEnrolled) {
            this.sendListDriversToEnrollment();
          }
        }
      });
    }

    if (this.driverEnrollmentService.hasUnrolledPermission) {
      this.menuItemsEnrolled.push({
        label: 'Desenrollar',
        icon: 'pi pi-sign-out',
        command: () => {
          console.log(this.selectedDriversEnrolled, "Desenrollar");
          this.returnListDriversFull();
        }
      });
    }
  }
}
